import { List,Record } from "immutable";

import createFromJS from "../../createFromJS";

export const SyncConflictRecord = Record({
  localId: null,
  externalId: null,
  fields: List()
});

const data = {
  objects: {
    fields: "List"
  }
};
createFromJS.registerCallback("SyncConflictRecord", createFromJS.createNestedCallback(SyncConflictRecord, data));
